<span [ngClass]="{'text-secondary-color hand': params?.isFromVendorpop}" class="hand" (click)="changeRoute(params)" >{{dataToShow}}</span>

